import { Button, NineSliceContainer } from "@ravalmatic/catafractum-utils";
import { GameVars } from "../../GameVars";

export class AvatarSelectionLayer extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene, selectedId: number, onSelect: (avatarId: number) => void, onClose: () => void) {

        super(scene);
        this.setDepth(3000);

        const darkLayer = new Phaser.GameObjects.Rectangle(this.scene, 0, 0, GameVars.gameWidth, GameVars.gameHeight, 0x000000, .5).setOrigin(0).setInteractive();
        darkLayer.on(Phaser.Input.Events.POINTER_UP, onClose);
        this.add(darkLayer);

        const landscape = GameVars.isLandscape;
        const width = landscape ? 980 : 760;
        const height = landscape ? 760 : 1100;
        const columns = landscape ? 6 : 4;
        const scale = landscape ? .675 : .725;
        const spacingX = landscape ? 140 : 150;
        const spacingY = landscape ? 145 : 150;
        const firstRowY = landscape ? -195 : -350;
        const menu = new Phaser.GameObjects.Container(scene, GameVars.gameWidth / 2, GameVars.gameHeight / 2);
        menu.setScale(1, GameVars.scaleY);
        this.add(menu);

        const background = new NineSliceContainer(scene, 0, 0, "texture_atlas_1", "bg_generic", width, height, 80);
        background.setInteractive({
            hitArea: new Phaser.Geom.Rectangle(-width / 2, -height / 2, width, height),
            hitAreaCallback: Phaser.Geom.Rectangle.Contains
        });
        background.on(Phaser.Input.Events.POINTER_UP,
            (_pointer: Phaser.Input.Pointer, _x: number, _y: number, event: Phaser.Types.Input.EventData) => {
                event.stopPropagation();
            });
        menu.add(background);

        const menuTitle = new Phaser.GameObjects.Text(scene, 0, landscape ? -324 : -492, "CHOOSE YOUR AVATAR", {
            fontFamily: "Baloo2-Bold", fontSize: landscape ? "54px" : "46px", color: "#FFFFFF"
        }).setOrigin(.5).setShadow(0, 3, "#000000", 4, false, true);
        menu.add(menuTitle);


        const avatarIds = [
            13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24,
            1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12
        ];
        avatarIds.forEach((avatarId, index) => {
            const x = (index % columns - (columns - 1) / 2) * spacingX;
            const y = firstRowY + Math.floor(index / columns) * spacingY;
            const tile = new Phaser.GameObjects.Graphics(scene);
            tile.setPosition(x, y);
            tile.fillStyle(0xf5a623, 1);
            tile.fillRoundedRect(-89 * scale, -103 * scale, 178 * scale, 206 * scale, 30 * scale);
            if (avatarId === selectedId) {
                tile.lineStyle(4, 0x19364d, 1);
                tile.strokeRoundedRect(-89 * scale, -103 * scale, 178 * scale, 206 * scale, 30 * scale);
            }
            menu.add(tile);
            const button = new Button(scene, x, y, "avatar_atlas", `avatar_${avatarId}`);
            button.setScale(scale);
            button.setInflationTween(1.05, scale, scale);
            const syncTileScale = () => tile.setScale(button.scaleX / scale);
            button.on(Phaser.Input.Events.POINTER_OVER, syncTileScale);
            button.on(Phaser.Input.Events.POINTER_OUT, syncTileScale);
            button.on(Phaser.Input.Events.POINTER_DOWN, syncTileScale);
            button.on(Phaser.Input.Events.POINTER_UP, syncTileScale);
            button.onUp(() => onSelect(avatarId), this);
            menu.add(button);
        });

        this.setAlpha(0);
        scene.tweens.add({ targets: this, alpha: 1, duration: 450, ease: "Cubic.Out" });
    }

    public destroy(fromScene?: boolean): void {

        if (!this.scene) return;
        this.scene.tweens.killTweensOf(this);
        super.destroy(fromScene);
    }
}
